import React, { useState } from 'react';
import styles from './AccountCard.module.scss';
import logo from '../../../../../../../assets/icons/vector/google-rounded.svg';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import ConfirmationModal from 'component/hoc/success-modal/ConfirmationModal';

const AccountCard = () => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  return (
    <div className={styles['account-card']}>
      <div className={styles['title-container']}>
        <div className={styles['title']}>
          <img src={logo} className={styles['logo']} />
          <p className={styles['title-text']}>Google</p>
        </div>
        <SvgWithBranding
          type='delete2'
          onClick={() => setShowDeleteModal(true)}
        />
      </div>
      <div className={styles['email-container']}>
        <p className={styles['email']}>uat3@uat3.com</p>
        <p className={styles['date']}>Added on 25/09/2025</p>
      </div>
      <ConfirmationModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onSubmit={() => {}}
        closeOnSubmit={true}
        onApproveButton={{ text: 'Delete' }}
        text='Delete Account'
        subText={`This will unlink the account from this user. This action cannot be undone`}
      />
    </div>
  );
};

export default AccountCard;
